 /* eslint-disable */
<template>
  <div class="dashboard">
    <Index/>
  </div>
</template>

<script>
// @ is an alias to /src
 import Index from '@/components/dashboard/Index.vue';

export default {
  name: "dashboard",
  components:{
    Index
  }
};
</script>
